import { render, staticRenderFns } from "./BoardDisabled.vue?vue&type=template&id=0afba61e&scoped=true&"
import script from "./BoardDisabled.vue?vue&type=script&lang=js&"
export * from "./BoardDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afba61e",
  null
  
)

export default component.exports